import { render, staticRenderFns } from "./wdsxsq.vue?vue&type=template&id=13809ff0&scoped=true"
import script from "./wdsxsq.vue?vue&type=script&lang=js"
export * from "./wdsxsq.vue?vue&type=script&lang=js"
import style0 from "./wdsxsq.vue?vue&type=style&index=0&id=13809ff0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13809ff0",
  null
  
)

export default component.exports